export enum LorenFieldTypes {
    INPUT,
    TEXTAREA,
    SELECT,
    CHECKBOX,
    DATETIME,
    COLOR,
    PERIOD,
    AUTOCOMPLETE,
    SLIDE_TOGGLE,
    FORM_SEPARATOR,
    CALENDAR,
}
